import { render } from "./ChoiceControl.vue?vue&type=template&id=8da5cb6c&ts=true"
import script from "./ChoiceControl.vue?vue&type=script&lang=ts"
export * from "./ChoiceControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__